// Money is stored as integer grosze on the wire. The shop UI shows zł.

export function groszeToZl(grosze: number): number {
  return grosze / 100;
}

export function formatGroszeAsZl(grosze: number): string {
  return groszeToZl(grosze).toFixed(2).replace('.', ',') + ' zł';
}

export function formatZlNumber(zl: number): string {
  return zl.toFixed(2).replace('.', ',') + ' zł';
}
